import { type ReactNode, useEffect, useRef, useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import BootstrapTooltip from 'react-bootstrap/Tooltip';
import { noop } from 'libs';

interface TooltipProps {
  children: ReactNode;
  className?: string;
  content: ReactNode;
  onVisibilityChange?: (visible: boolean) => void;
  placement?: 'bottom' | 'left' | 'right' | 'top';
}

const Tooltip = ({ children, className, content, onVisibilityChange = noop, placement = 'right' }: TooltipProps) => {
  const [persist, setPersist] = useState(false);
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const isVisible = persist || show;

  useEffect(() => {
    onVisibilityChange(isVisible);
  }, [isVisible, onVisibilityChange]);

  return (
    <div className={className}>
      <span
        className="cursor-pointer d-inline-flex mw-full overflow-hidden"
        onClick={() => setPersist(true)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        ref={target}
      >
        {children}
      </span>
      <Overlay
        onHide={() => setPersist(false)}
        placement={placement}
        rootClose
        rootCloseEvent="mousedown"
        show={isVisible}
        target={target.current}
      >
        {(props) => <BootstrapTooltip {...props}>{content}</BootstrapTooltip>}
      </Overlay>
    </div>
  );
};

export default Tooltip;
